import { IProgressBarProperties } from "../../properties/BarProperties";

const ProgressBar = ({
  title,
  showRemainingTime,
  totalTimeInSeconds,
  remainingTimeInSeconds,
  color,
  borderColor,
  height,
}: IProgressBarProperties) => {
  const retrieveMinutes = () => {
    return Math.floor(remainingTimeInSeconds / 60);
  };

  const retrieveSeconds = (minutes: number) => {
    const minuteInSeconds = minutes * 60;
    return Math.floor(remainingTimeInSeconds - minuteInSeconds);
  };

  const calculatePercentage = () => {
    if (remainingTimeInSeconds < 0) {
      return (totalTimeInSeconds / totalTimeInSeconds) * 100;
    } else {
      return (
        ((totalTimeInSeconds - remainingTimeInSeconds) / totalTimeInSeconds) *
        100
      );
    }
  };

  const currentMinutes = retrieveMinutes();
  const currentSeconds = retrieveSeconds(currentMinutes);

  return (
    <div className="bar-prog">
      <div>
        {title ? (
          <div className="bar-prog-title">
            <span className="bar-prog-title-text">{title}</span>
          </div>
        ) : null}

        {showRemainingTime ? (
          <div className="bar-prog-time">
            <span className="bar-prog-time-inner">
              <p className="bar-prog-digit">
                {currentMinutes < 0
                  ? `00`
                  : currentMinutes < 10
                  ? `0${currentMinutes}`
                  : currentMinutes}{" "}
              </p>
              :
              <p className="bar-prog-digit">
                {currentSeconds < 0
                  ? `00`
                  : currentSeconds < 10
                  ? `0${currentSeconds}`
                  : currentSeconds}{" "}
              </p>
            </span>
          </div>
        ) : null}

        <div
          className={`${
            borderColor ? borderColor : "bar-prog-border-default"
          } bar-prog-frame`}
        >
          <div className={`bar-prog-track ${height ? height : ""}`}>
            <div
              className={`bar-prog-fill ${
                color ? color : "bar-prog-fill-default"
              } ${height ? height : "bar-prog-h-default"}`}
              style={{ width: `${calculatePercentage()}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
